<template>
	<div>
		<div>
			<p><b>Invoice Date</b></p>
			<date-time v-model="invoice_date" :date="invoice_date"></date-time>
		</div>
		<div class="vertical_space"></div>
		<div class="vertical_space"></div>
		<div>
			<p><b>Payment Date</b></p>
			<date-time v-model="payment_date" :date="payment_date"></date-time>
		</div>
		<div class="modal_footer">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading }"
				class="button is-info"
				>Submit</a
			>
		</div>
	</div>
</template>
<script>
	import { mapMutations, mapActions } from 'vuex'
	import DateTime from '@/components/DateTime'
	export default {
		name: 'add-offer-dates-suggestion',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				invoice_date: undefined,
				payment_date: undefined
			}
		},
		created(){
			this.$network_utils.getOffer(this.payload.offer_id).then(response => {
				this.invoice_date = response.invoice_date
				this.payment_date = response.payment_date
			})
		},
		methods: {
			submit(){
				this.is_loading = true
				this.$network_utils.updateOffer({
					id: this.payload.offer_id,
					invoice_date: this.invoice_date,
					payment_date: this.payment_date
				}).then(() => {
					this.removeModal(this.payload)
					this.showToast('עודכן בהצלחה')
				})
			},
			...mapActions('toasts', ['showToast']),
			...mapMutations('modals', ['removeModal'])
		},
		components: {
			DateTime
		}
	}
</script>